export default "__VITE_ASSET__CvcyQE7W__"